var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-icon',{style:({ width: _vm.width, height: _vm.height }),attrs:{"name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }